/**
 * Light-only staff UI on application detail (dealer / internal lens).
 * Solid backgrounds only — no opacity fills, no dark: variants — so panels
 * render the same regardless of OS dark mode or GPU compositing.
 */
export const staffUi = {
  workspaceStrip:
    "mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-2xl border border-indigo-200 bg-indigo-50 px-4 py-4 sm:px-5 shadow-sm",
  workspaceEyebrow: "text-[11px] font-bold uppercase tracking-[0.2em] text-indigo-700",
  workspaceBody: "text-sm text-slate-600 leading-snug",
  staffOnlyPanel: "mt-4 rounded-xl border border-violet-200 bg-violet-50 p-3 sm:p-4 space-y-4",
  staffOnlyEyebrow: "text-[11px] font-bold uppercase tracking-widest text-violet-800",
  staffOnlySectionBtn:
    "w-full flex items-center justify-between gap-2 text-sm font-medium text-violet-900 mb-2 hover:opacity-90 text-left",
  internalCard: "border border-indigo-200 bg-white shadow-sm",
  sosPanel: "mt-4 rounded-lg border border-slate-200 bg-slate-50 p-3 sm:p-4 space-y-3",
  offerRow: "rounded-lg border border-gray-200 bg-white p-3 text-sm",
  offerRowSelected: "rounded-lg border-2 border-primary bg-primary-50 p-3 text-sm",
  offerRowUnmatched: "rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm",
  insetPanel: "rounded-lg border border-gray-200 bg-gray-50 p-3",
  warningPanel: "rounded-lg border border-amber-200 bg-amber-50 p-3",
} as const;
